// extracted by mini-css-extract-plugin
export default {"primaryBanner":"PrimaryBanner_primaryBanner__qVBV+","primaryBannerImage":"PrimaryBanner_primaryBannerImage__XJb5D","textContainer":"PrimaryBanner_textContainer__pEkHZ"};